import { Skeleton } from "../../../../../components/atoms/Skeleton";
import "./SkeletonKpisCards.css";

export function SkeletonKpisCards({ style, amountOfDays }) {
  return (
    <div
      className="skeleton-kpis-cards"
      style={style}>
      {Array.from({ length: amountOfDays > 1 ? 6 : 3 }).map((_, i) => {
        return (
          <Skeleton
            key={i}
            className="kpi-skeleton-card"
          />
        );
      })}
    </div>
  );
}
